var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgH1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5C21.4142 4.5 21.75 4.83579 21.75 5.25V18.75C21.75 19.1642 21.4142 19.5 21 19.5V19.5C20.5858 19.5 20.25 19.1642 20.25 18.75V6.76947C20.25 6.56779 20.0865 6.4043 19.8848 6.4043V6.4043C19.815 6.4043 19.7465 6.42434 19.6877 6.46206L17.1814 8.06899C16.6643 8.40051 15.9852 8.0292 15.9852 7.41497V7.41497C15.9852 7.1503 16.1199 6.90384 16.3427 6.76097L19.4988 4.73728C19.7404 4.58235 20.0214 4.5 20.3084 4.5H21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5C2.58579 19.5 2.25 19.1642 2.25 18.75V5.25C2.25 4.83579 2.58579 4.5 3 4.5V4.5C3.41421 4.5 3.75 4.83579 3.75 5.25V11.25H11.25V5.27275C11.25 4.84597 11.596 4.5 12.0228 4.5V4.5C12.4495 4.5 12.7955 4.84597 12.7955 5.27275V18.7272C12.7955 19.154 12.4495 19.5 12.0228 19.5V19.5C11.596 19.5 11.25 19.154 11.25 18.7272V12.8613H3.75V18.75C3.75 19.1642 3.41421 19.5 3 19.5V19.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgH1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/h1.371b1ffbd8ba1020c8f6e4cc6864ea6b.svg";